import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import QrCodeScannerOutlinedIcon from "@mui/icons-material/QrCodeScannerOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import { Button, THEME } from "@myloc/myloc-gui";
import classNames from "classnames";
import { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useTranslate } from "../../../language/i18n";
import { openOrderPopup } from "../../../reducers/dialog/dialogAction";
import { selectHasFSPAccess } from "../../../reducers/session/sessionSelectors";
import pages from "../../../utils/pages";
import ScannerDialog from "../../shared/scanner/ScannerDialog";
import styles from "./MobileMenu.module.scss";
import SearchDrawer from "./SearchDrawer/SearchDrawer";
import useScanner from "./useScanner";

function MobileMenu() {
  const translate = useTranslate();
  const userLoggedIn = !!useSelector(state => state.session.sessionId);
  const order = useSelector(state => state.appData.order);
  const [menuVisible, setMenuVisible] = useState("");
  const hasFSPAccess = useSelector(selectHasFSPAccess);
  const { isLoading, scannerOpen, openScanner, handleScan, closeScanner } = useScanner();

  const onItemClick = e => {
    e.preventDefault, menuVisible && toggleDrawer();
  };

  const toggleDrawer = menu => {
    setMenuVisible(menuVisible === menu ? "" : menu);
  };

  return (
    <>
      {userLoggedIn && (
        <>
          <section className={styles.menu}>
            {hasFSPAccess && (
              <>
                <button
                  className={classNames(styles.link, menuVisible && styles.active)}
                  onClick={e => {
                    e.preventDefault;
                    toggleDrawer("SEARCH");
                  }}
                >
                  <SearchOutlinedIcon />
                  <span className={styles.text}>{translate("SEARCH")}</span>
                </button>

                <NavLink
                  to={pages.PRODUCTS.PATH}
                  className={styles.link}
                  activeClassName={styles.active}
                  onClick={e => onItemClick(e)}
                >
                  <SellOutlinedIcon />
                  <span className={styles.text}>{translate(pages.PRODUCTS.NAME)}</span>
                </NavLink>

                <Button
                  theme={THEME.PLAIN}
                  customCssClass={styles.link}
                  onClick={e => {
                    onItemClick(e), openOrderPopup({ receiverType: order?.receiver?.type });
                  }}
                >
                  <AddOutlinedIcon />
                  <span className={styles.text}>{translate(order?.receiver?.type ? "ADD_TO_ORDER" : "NEW_ORDER")}</span>
                </Button>

                <button className={styles.link} onClick={openScanner}>
                  <QrCodeScannerOutlinedIcon />
                  <span className={styles.text}>{translate("SCAN")}</span>
                </button>

                <NavLink
                  to={pages.MY_MYLOC.PATH}
                  className={styles.link}
                  activeClassName={styles.active}
                  onClick={e => onItemClick(e)}
                >
                  <PersonOutlinedIcon />
                  <span className={styles.text}>{translate("MY_MYLOC")}</span>
                </NavLink>
              </>
            )}
          </section>

          <SearchDrawer visible={menuVisible === "SEARCH"} onMenuLinkClick={() => toggleDrawer("SEARCH")} />
          <ScannerDialog onScan={handleScan} open={scannerOpen} handleClose={closeScanner} isLoading={isLoading} />
        </>
      )}
    </>
  );
}

export default MobileMenu;
